import React from "react";
import { useTranslation } from "react-i18next";

const ContractProcessHeader = () => {
  const t = useTranslation("contractProcess\\contractProcess").t;

  return (
    <div className={"d-none d-sm-block px-3 mb-2 text-muted font-weight-bold mr-5"}>
      <div className="row no-gutters align-items-center">
        <div className="col">
          <div className="row no-gutters align-items-center">
            <div className="col-12 col-sm-5 col-md-5 col-lg-4 text-truncate">
              <span className="d-none d-lg-inline">
                {t("header.placeOfDeliveryName.desktop")}
              </span>
              <span className="d-lg-none">
                {t("header.placeOfDeliveryName.mobile")}
              </span>
            </div>

            <div className="col-12 col-sm-7 col-md-7 col-lg-8">
              <div className="row no-gutters align-items-center">
                <div className="col-12 col-sm-6 col-md-5 col-lg-6">
                  <div className="row no-gutters align-items-center">
                    <div className="col-12 col-xl-6 text-truncate">
                      <span className="d-xl-none">
                        {t("header.contractNumberShort")}
                      </span>
                      <span className="d-none d-xl-inline">
                        {t("header.contractNumber")}
                      </span>
                    </div>
                    <div className="d-none d-xl-block col-xl-6 text-truncate">
                      {t("header.effectiveDate")}
                    </div>
                  </div>
                </div>

                <div className="col-12 col-sm-6 col-md-7 col-lg-6">
                  <div className="row no-gutters align-items-center">
                    <div className="col-12 col-xl-6 text-truncate">
                      {t("header.processName")}
                    </div>
                    <div className="d-none d-xl-block col-xl-6 text-truncate">
                      {t("header.processState")}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContractProcessHeader;
